export const config = {
    api: {
        baseUrl: 'https://api-tweb-efleet-justpay.justit.cloud/api',        
        timeout: 30000,
    },
    encryption: {
        enabled: true,
    },
    features: {
        xmlUpload: true,
        emailReceipt: true,
        printReceipt: true,
    },
} as const;

